import * as React from "react";
const IconFirstAid = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M26.9 31.7h2.8v2.8c0 1.2 1 2.2 2.2 2.2s2.2-1 2.2-2.2v-2.8h2.8c1.2 0 2.2-1 2.2-2.2s-1-2.2-2.2-2.2h-2.8v-2.8c0-1.2-1-2.2-2.2-2.2s-2.2 1-2.2 2.2v2.8h-2.8c-1.2 0-2.2 1-2.2 2.2s1 2.2 2.2 2.2" />
    <path d="M56.1 14.5H41.9v-2.8c0-4-3.3-7.3-7.3-7.3h-5.1c-4 0-7.3 3.3-7.3 7.3v2.8H7.9c-3.4 0-6.1 2.7-6.1 6.1v12.1c0 2 1 3.8 2.5 4.8V54c0 3.1 2.5 5.7 5.6 5.7h44.3c3.1 0 5.6-2.6 5.6-5.7V37.5c1.5-1.1 2.5-2.9 2.5-4.9v-12c-.1-3.4-2.8-6.1-6.2-6.1m-29.5-2.9c0-1.6 1.3-2.8 2.8-2.8h5.1c1.6 0 2.8 1.3 2.8 2.8v2.8H26.6zm-20.4 9c0-.9.8-1.6 1.7-1.6h48.4c.9 0 1.6.7 1.6 1.6v12.1c0 .7-.5 1.3-1 1.4-1 .1-1.8.3-2.5.5l-14.8 4.1c-4.9 1.4-10.1 1.4-15 0L9.7 34.5c-.7-.2-1.4-.3-2-.4h-.2c-.7-.2-1.2-.7-1.2-1.4V20.6zm47.9 34.6H9.9c-.6 0-1.1-.5-1.1-1.2V39l14.4 4q4.35 1.2 8.7 1.2c4.35 0 5.9-.4 8.7-1.2l14.5-4.1V54c.1.7-.4 1.2-1 1.2" />
  </svg>
);
export default IconFirstAid;
